/* dse-v3.js · Dossier Estetico (IT) · landing v3 · 2026-10-22
   Lo que no es movimiento-pro: planes con su botón al carrito + bumps + casilla de entrega (UE), barra fija que sale solo
   desde la oferta (SF-011), deslizador antes/después, selector Medico / Estetista (las dos respuestas están escritas en el
   HTML; no guarda datos), visor ampliado y vídeo que solo se reproduce mientras se ve. Sin dependencias.
   En la sección Liquid las variantes y el carrito salen de Shopify (data-variante / data-carrito). */
(function () {
  'use strict';
  var d = document, W = window;
  var raiz = d.querySelector('[data-dse]') || d.body;
  var $ = function (s, c) { return (c || raiz).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || raiz).querySelectorAll(s)); };
  var reducir = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var moneda = raiz.getAttribute('data-moneda') || 'EUR', locale = raiz.getAttribute('data-locale') || 'it-IT';
  function fmt(c) { try { return new Intl.NumberFormat(locale, { style: 'currency', currency: moneda }).format(c / 100); } catch (e) { return (c / 100).toFixed(2) + ' ' + moneda; } }
  function cent(el) { return parseInt(el.getAttribute('data-precio'), 10) || 0; }

  /* ---------- Planes: cada uno con su botón al pago; las casillas de consentimiento se espejan ---------- */
  var planes = $$('[data-plan]'), casillas = $$('[data-consent]');
  function consentido() { return casillas.some(function (c) { return c.checked; }); }
  function enlace(plan) {
    var btn = $('[data-comprar]', plan); if (!btn) return;
    if (!consentido()) { btn.setAttribute('href', '#offerta'); return; }
    var items = [plan.getAttribute('data-variante') + ':1'];
    $$('[data-extra]', plan).forEach(function (x) { if (x.checked) items.push(x.getAttribute('data-variante') + ':1'); });
    btn.setAttribute('href', btn.getAttribute('data-carrito') + '/' + items.join(',') + '?attributes%5B' +
      encodeURIComponent(btn.getAttribute('data-atributo')) + '%5D=' + encodeURIComponent(btn.getAttribute('data-valor') + ' ' + new Date().toISOString()));
  }
  function totales(plan) {
    var c = cent(plan);
    $$('[data-extra]', plan).forEach(function (x) { if (x.checked) c += cent(x); });
    $$('[data-total]', plan).forEach(function (t) { t.textContent = fmt(c); });
  }
  var caja = $('[data-caja]'), msg = $('[data-msg]'), cb = $('[data-consent]');
  planes.forEach(function (plan) {
    var btn = $('[data-comprar]', plan);
    totales(plan); enlace(plan);
    $$('[data-extra]', plan).forEach(function (x) { x.addEventListener('change', function () { totales(plan); enlace(plan); }); });
    if (!btn || !cb) return;
    btn.addEventListener('click', function (e) {
      if (!consentido()) {
        e.preventDefault(); msg.hidden = false; caja.classList.add('error'); cb.setAttribute('aria-invalid', 'true'); cb.focus();
        caja.scrollIntoView({ block: 'center', behavior: reducir ? 'auto' : 'smooth' });
      }
    });
  });
  if (cb) cb.addEventListener('change', function () {
    if (cb.checked) { msg.hidden = true; caja.classList.remove('error'); cb.removeAttribute('aria-invalid'); }
    planes.forEach(enlace);
  });

  /* ---------- Barra fija: aparece al llegar a la oferta y se esconde mientras se ve el bloque de compra ---------- */
  var fija = $('[data-fija]'), compra = $('[data-sec="comprar"]'), pend = false;
  function mira() {
    pend = false; if (!fija || !compra) return;
    var vh = W.innerHeight, c = compra.getBoundingClientRect();
    var pasada = c.top < vh * 0.6, enCompra = c.top < vh * 0.85 && c.bottom > vh * 0.25;
    var ver = pasada && !enCompra;
    fija.classList.toggle('vista', ver); fija.setAttribute('aria-hidden', ver ? 'false' : 'true');
    var a = fija.querySelector('a'); if (a) a.tabIndex = ver ? 0 : -1;
  }
  if (fija) { W.addEventListener('scroll', function () { if (!pend) { pend = true; requestAnimationFrame(mira); } }, { passive: true }); W.addEventListener('resize', mira); mira(); }

  /* ---------- Deslizador antes / después ---------- */
  $$('[data-confronto]').forEach(function (box) {
    var r = box.querySelector('input[type="range"]'); if (!r) return;
    var pon = function () { box.style.setProperty('--x', r.value + '%'); };
    r.addEventListener('input', pon); pon();
    if (!reducir && 'IntersectionObserver' in W) { /* una pista suave la primera vez que se ve: enseña que se puede arrastrar */
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        var t0 = performance.now();
        (function f(t) { var k = Math.min((t - t0) / 1400, 1), v = 50 + Math.sin(k * Math.PI * 2) * 18 * (1 - k); r.value = v; pon(); if (k < 1) requestAnimationFrame(f); })(t0);
      }, { threshold: 0.6 });
      io.observe(box);
    }
  });

  /* ---------- Selector Medico / Estetista ---------- */
  var tabs = $$('[role="tab"]');
  function elige(i, enfoca) {
    tabs.forEach(function (t, k) {
      var on = k === i; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
      var p = d.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
    });
    if (enfoca) tabs[i].focus();
  }
  tabs.forEach(function (t, i) {
    t.tabIndex = i === 0 ? 0 : -1;
    t.addEventListener('click', function () { elige(i, false); });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); elige((i + 1) % tabs.length, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); elige((i - 1 + tabs.length) % tabs.length, true); }
    });
  });

  /* ---------- Visor ampliado ---------- */
  var visor = $('[data-visor]'), vimg = $('[data-visor-img]');
  if (visor && vimg) {
    $$('[data-grande]').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = b.querySelector('img'); vimg.src = b.getAttribute('data-grande'); vimg.alt = s ? s.alt : '';
        if (visor.showModal) visor.showModal(); else W.open(vimg.src);
      });
    });
    $('[data-chiudi]', visor).addEventListener('click', function () { visor.close(); });
    visor.addEventListener('click', function (e) { if (e.target === visor) visor.close(); });
  }

  /* ---------- cierre Europa 04 · selector de 3 preguntas: recomienda un plan y lo marca; no guarda nada ---------- */
  $$('[data-ce-selector]').forEach(function (sel) {
    var umbral = parseInt(sel.getAttribute('data-umbral') || '2', 10), preg = $$('fieldset', sel);
    sel.addEventListener('change', function () {
      var resp = 0, pts = 0;
      preg.forEach(function (f) { var x = f.querySelector('input:checked'); if (!x) return; resp++; if (x.value === '1') pts++; });
      if (resp < preg.length) return;
      var completo = pts >= umbral, id = completo ? 'ce-plan-completo' : 'ce-plan-basico', res = $('[data-ce-res]', sel);
      res.hidden = false; $('[data-ce-res-basico]', sel).hidden = completo; $('[data-ce-res-completo]', sel).hidden = !completo;
      $('[data-ce-ir]', sel).setAttribute('href', '#' + id);
      planes.forEach(function (p) { p.classList.toggle('ce-recomendado', p.id === id); });
    });
  });

  /* ---------- Vídeo del hojeo: solo se reproduce mientras se ve (y nunca con movimiento reducido) ---------- */
  $$('video[data-video]').forEach(function (v) {
    if (reducir || !('IntersectionObserver' in W)) { v.setAttribute('controls', ''); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
    }, { threshold: 0.35 }).observe(v);
  });
})();
